import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

import { tr } from "../lib/i18n";
const field = "w-full h-10 rounded-lg border border-[hsl(var(--border))] px-3 text-sm";

/** Save a chat visitor as a customer (merged by mobile) with the transcript and vehicle attached. */
export const ConvertChatModal = ({ conv, onClose, onSaved }) => {
  const [form, setForm] = useState({ name: conv.name || "", mobile: conv.phone || "", email: conv.email || "", vehicle_id: conv.vehicle_id || "" });
  const [vehicles, setVehicles] = useState([]);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => {
    api.get("/vehicles", { params: { limit: 200 } }).then(({ data }) => setVehicles(data.items || [])).catch(() => {});
  }, []);

  const save = async () => {
    if (!form.name.trim() || !form.mobile.trim()) { toast.error(tr("x.name_and_mobile_number_are_required")); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/chat/conversations/${conv.id}/convert-to-lead`, { ...form, vehicle_id: form.vehicle_id || null });
      toast.success(data.merged ? `Added to existing customer ${data.customer.name}` : `Customer ${data.customer.name} created`);
      onSaved(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="panel p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} data-testid="convert-chat-modal">
        <div className="eyebrow mb-3">{tr("x.save_as_customer")}</div>
        <div className="space-y-3">
          <input className={field} placeholder={tr("x.full_name")} value={form.name} onChange={set("name")} data-testid="convert-name" />
          <input className={field} placeholder={tr("x.mobile")} inputMode="tel" value={form.mobile} onChange={set("mobile")} data-testid="convert-mobile" />
          <input className={field} placeholder={tr("x.email")} value={form.email} onChange={set("email")} data-testid="convert-email" />
          <select className={field} value={form.vehicle_id} onChange={set("vehicle_id")} data-testid="convert-vehicle">
            <option value="">{tr("x.no_vehicle")}</option>
            {vehicles.map((v) => <option key={v.id} value={v.id}>{v.stock_number} · {v.make} {v.model} {v.model_year}</option>)}
          </select>
          <div className="text-xs opacity-60">{tr("x.if_a_customer_with_this_mobile_already_e")}</div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-secondary" data-testid="convert-cancel">{tr("x.cancel")}</button>
          <button onClick={save} disabled={busy} className="btn-primary" data-testid="convert-submit">{busy ? tr("x.saving") : tr("x.save_customer")}</button>
        </div>
      </div>
    </div>
  );
};
